import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGroupCreationControl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.31486 9.98911C11.7971 9.98911 13.8094 7.97683 13.8094 5.49456C13.8094 3.01228 11.7971 1 9.31486 1C6.83259 1 4.82031 3.01228 4.82031 5.49456C4.82031 7.97683 6.83259 9.98911 9.31486 9.98911Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 18.9787C1.51984 17.2107 2.59307 15.6501 4.06628 14.52C5.53949 13.3899 7.33726 12.748 9.20256 12.6863C12.9575 12.6863 16.1565 15.3021 17.4051 18.9787",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3575 3.02246C17.0393 3.38377 17.591 3.96163 17.9315 4.67113C18.2719 5.38061 18.3833 6.18424 18.249 6.96398C18.1148 7.7437 17.7421 8.45831 17.1857 9.00287C16.6295 9.54734 15.9187 9.89299 15.1582 9.98902",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.832 12.2363C17.046 12.5458 18.1594 13.1634 19.0649 14.0296C19.9704 14.8957 20.6371 15.9809 21.0008 17.1803",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconGroupCreationControl;
